<template>
    <div class="Details">
    <section>
        <div class="x">
            
            <div class="field is-grouped ">
                
            </div>

            <div class="box">
                <h4 class="title is-6">Document statistics&nbsp;
                    
                        
                            <!-- <b-button class="button is-info is-light is-small"
                                tag="button"
                                @click="refreshStatistics()"
                                value="Refresh statistics">
                                Refresh statistics
                            </b-button> -->
                        
                </h4>
                <p>
                    Total of {{ dataset.instances }} documents.<br>
                    Containing {{ dataset.tokens }} tokens.<br>
                </p>
            </div>
            
            <div class="box ">
                <h4 class="title is-6">Data quality</h4>
                
                <p>
                    <!-- Quality score: {{ dataset.label_score.toFixed(3)*1000 }}/1000<br> -->
                    <b-tag type="is-success">Ok</b-tag> No null documents.<br>
                    <b-tag type="is-success">Ok</b-tag> No redundant documents.<br>
                    <span v-if="unbalancedLabels.length > 0">
                    <b-tag type="is-danger">Attention</b-tag> Unbalanced labels.
                    Labels with fewer data: {{ unbalancedLabels.join([separador = ', ']) }}
                    </span>
                </p>
            </div>
            <div class="box" v-if="dataset.labelBalance">
                <h4 class="title is-6">Label distribution</h4>
                

                <b-message v-if="unbalanced">
                    <strong>Imbalanced label distribution</strong>.
                     It can cause poor performance on model training and evaluation metrics. 
                     To solve this, you can opt to do an undersampling on training or collect more data.
                </b-message>

                <!--Plotly v-if="balancePlot" :data="balancePlot" :layout="layout" :display-mode-bar="true"></Plotly-->
                <apexchart v-if="balancePlot.series" width="100%" height="400px" type="bar" :options="balancePlot.options" :series="balancePlot.series"></apexchart>

                <!--h4 class="title is-6">Average Text Length by Label</h4>
                <apexchart v-if="textLengthPlot.series" width="100%" height="400px" type="bar" :options="textLengthPlot.options" :series="textLengthPlot.series"></apexchart-->

                <b-skeleton v-else width="100%" :animated="animated"></b-skeleton>

            </div>

            <div v-if="dataset.unigrams">
                <div class="box">
                    <h4 class="title is-6">Unigrams wordcloud</h4>

                    <vue-word-cloud
                        style="
                            height: 480px;
                            width: 640px;
                        "
                        :words="Object.entries(dataset.unigrams)"
                        color="#3a9eea"
                        font-family="Roboto"
                        />
                </div>


                <div class="box">

                    <h3 class="title is-6">Bigrams wordcloud</h3>

                    <vue-word-cloud
                        style="
                            height: 480px;
                            width: 640px;
                        "
                        :words="Object.entries(dataset.bigrams)"
                        color="#3a9eea"

                        font-family="Roboto"
                        />
                </div>
            </div>

        </div>
        

    </section>

    </div>
</template>
<script>
import firebase from 'firebase/compat/app';
import DataFrame from 'dataframe-js';
import axios from 'axios';
import VueWordCloud from 'vuewordcloud';

import { Plotly } from 'vue-plotly'

   export default {
     props: ["dataset", "wordclouds"],
     name: "Data",
     data: function() {
    return {
        json: [1],
        unbalanced: false,
        unbalancedLabels: [],
        tableData: false,
        tableSort: ['label', 'text'],
        animated: true,
        balancePlot: false,
        dataset_url: null,
        data_plot: null,
        fill:  {
          
          
        },
    }},
    components: {
        Plotly,
        VueWordCloud
    },
    computed: {
    //    dataset() {
    //      return this.$store.state.dataset;
    //    }
     },
     mounted(){
        
     },
     methods: {
        async refreshStatistics() {
            this.isLoading = true
            // this.$buefy.notification.open(`Calling model API`)
            //this.$buefy.notification.open('Request time: '+parseFloat(response_time).toFixed(3)+' s.')
            const payload = {
                userId: firebase.auth().currentUser.uid, 
                datasetId: this.dataset.id
            }
            const result = await this.$store.dispatch("refreshDatasetAnalysisStatistics", payload);
            this.result = result
            this.isLoading = false
        },
        checkLabelBalance(labelCounts, labelNames){

            Array.prototype.median = function () {
                return this.slice().sort((a, b) => a - b)[Math.floor(this.length / 2)]; 
            };

            let sum = labelCounts.reduce((a, b) => a + b, 0);
            let avg = (sum / labelCounts.length) || 0;
            let median = labelCounts.median()
            let threshold = Math.min(avg, median) * 0.8

            let unbalancedLabels = []
            for(let i = 0; i < labelCounts.length; i++){
                if (labelCounts[i] < threshold){
                    unbalancedLabels.push(
                        labelNames[i]
                    )
                }
                
            }
            return unbalancedLabels
        }
     },
     created() {
        
        if (this.dataset.labelBalance){

            this.unbalancedLabels = this.checkLabelBalance(this.dataset.labelBalance['count'], this.dataset.labelBalance['labels'])
            
            this.balancePlot = {
                series: [{
                    name: "Instances",
                    data: this.dataset.labelBalance['count']
                }],
                options: {
                    xaxis: {
                        categories: this.dataset.labelBalance['labels']
                    },
                    // colors: ['#f3cec9', '#e7a4b6', '#cd7eaf', '#a262a9', '#6f4d96', '#3d3b72', '#182844']
                }
            }

            this.textLengthPlot = {
                series: [{
                    name: "Average Text Length",
                    data: this.dataset.labelBalance['mean_text_length']
                }],
                options: {
                    xaxis: {
                        categories: this.dataset.labelBalance['labels']
                    },
                    // colors: ['#f3cec9', '#e7a4b6', '#cd7eaf', '#a262a9', '#6f4d96', '#3d3b72', '#182844']
                }
            }
        }
        
     }
   };
</script>
<style scoped="">
img.preview {
    width: 200px;
}

</style>